export default "__VITE_ASSET__D6vo2LVv__"